import {
	Avatar,
	Box,
	Button,
	Chip,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
	Divider,
	Paper,
	IconButton,
} from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { getFromStorage, removeFromStorage } from '../utils/storage'
import { currentUserActions } from '../redux/store'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import ScheduleIcon from '@mui/icons-material/Schedule'
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import CheckIcon from '@mui/icons-material/Check'
import TableChartIcon from '@mui/icons-material/TableChart'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import MoveUpIcon from '@mui/icons-material/MoveUp'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { api } from '../utils/api'
import axios from 'axios'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { socket } from '../utils/socket'
import { mainRed } from '../utils/color'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import { apiBase } from '../services/apiBase'
import MenuIcon from '@mui/icons-material/Menu'
import { canAccessCashflow } from '../utils/cashflowPermissions'

export default function MenuPC({ isMenuCollapsed, setIsMenuCollapsed }) {
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const location = useLocation()
	const [guestOrdersQuantity, setGuestOrdersQuantity] = useState()
	const [allGuestOrdersQuantity, setAllGuestOrdersQuantity] = useState()
	const [remainingConfirm, setRemainingConfirm] = useState()
	const [scheduleOrderQuantity, setScheduleOrderQuantity] = useState()
	const [totalOrdersQuantityAndWeight, setTotalOrdersQuantityAndWeight] = useState()

	const getGuestOrdersQuantity = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_GUEST_ORDERS_QUANTITY_STORE_MANAGER,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setGuestOrdersQuantity(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	const getConfirmOrdersQuantity = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_CONFIRM_ORDERS_QUANTITY_STORE_MANAGER,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setRemainingConfirm(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	const getScheduleOrderQuantity = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_SCHEDULE_ORDERS_QUANTITY_STORE_MANAGER,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setScheduleOrderQuantity(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	const getTotalOrdersQuantityAndWeight = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_TOTAL_ORDERS,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setTotalOrdersQuantityAndWeight(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	useEffect(() => {
		if (currentUser.isLoggedIn) {
			getGuestOrdersQuantity()
			getConfirmOrdersQuantity()
			if (currentUser.role !== 'director' && currentUser.role !== 'admin' && currentUser.role !== 'assistant') {
				getScheduleOrderQuantity()
				getTotalOrdersQuantityAndWeight()
			}
		}
	}, [
		getGuestOrdersQuantity,
		getConfirmOrdersQuantity,
		getScheduleOrderQuantity,
		getTotalOrdersQuantityAndWeight,
		currentUser.isLoggedIn,
		currentUser.role,
	])

	useEffect(() => {
		const listener = (data) => {
			setGuestOrdersQuantity(data)
			getGuestOrdersQuantity()
		}
		socket.on(`get-guest-orders-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-guest-orders-quantity-${currentUser.store}`, listener)
		}
	})
	const getAllGuestOrdersQuantity = useCallback(async () => {
		try {
			const response = await apiBase.get(api.GET_ALL_GUEST_ORDERS_QUANTITY)
			setAllGuestOrdersQuantity(response)
		} catch (err) {
			console.error('Error fetching guest orders quantity:', err)
		}
	}, [])

	useEffect(() => {
		if (currentUser.isLoggedIn) {
			getAllGuestOrdersQuantity()
		}
	}, [getAllGuestOrdersQuantity, currentUser.isLoggedIn])

	useEffect(() => {
		const listener = (data) => {
			setAllGuestOrdersQuantity(data)
			getAllGuestOrdersQuantity()
		}
		socket.on('get-all-guest-orders-quantity', listener)
		return () => {
			socket.off('get-all-guest-orders-quantity', listener)
		}
	})

	useEffect(() => {
		const listener = () => {
			getConfirmOrdersQuantity()
		}
		socket.on(`get-confirm-orders-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-confirm-orders-quantity-${currentUser.store}`, listener)
		}
	})

	useEffect(() => {
		const listener = () => {
			getScheduleOrderQuantity()
		}
		socket.on(`get-schedule-orders-quantity-${currentUser.store}`, listener)
		return () => {
			socket.off(`get-schedule-orders-quantity-${currentUser.store}`, listener)
		}
	})

	const [copied, setCopied] = useState(false)
	const canUseCashflow = canAccessCashflow(currentUser)

	const menuItemStyle = {
		backgroundColor: 'rgba(76, 175, 80, 0.08)',
		transform: 'translateX(8px)',
		transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
		borderRadius: '8px',
		margin: '4px 12px',
		'&.Mui-selected': {
			backgroundColor: 'rgba(76, 175, 80, 0.15)',
			borderLeft: '4px solid #4CAF50',
		},
	}

	const menuIconStyle = {
		minWidth: '40px',
		color: '#666',
		transition: 'color 0.2s ease-in-out',
	}

	const menuTextStyle = {
		'& .MuiTypography-root': {
			fontWeight: 500,
			fontSize: '14px',
			color: '#333',
		},
	}

	const badgeStyle = {
		color: '#fff',
		background: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)',
		height: '22px',
		width: '22px',
		lineHeight: '22px',
		textAlign: 'center',
		borderRadius: '12px',
		fontSize: '11px',
		fontWeight: 'bold',
		boxShadow: '0 2px 8px rgba(255, 107, 107, 0.4)',
		animation: 'pulse 2s infinite',
		'@keyframes pulse': {
			'0%': {
				transform: 'scale(1)',
			},
			'50%': {
				transform: 'scale(1.05)',
			},
			'100%': {
				transform: 'scale(1)',
			},
		},
	}

	const handleLogout = () => {
		removeFromStorage('current-user')
		dispatch(currentUserActions.isLogout())
		navigate('/login')
	}

	return (
		<>
			{/* Collapse/Expand Button */}
			<IconButton
				onClick={() => setIsMenuCollapsed(!isMenuCollapsed)}
				sx={{
					position: 'fixed',
					top: 75,
					left: 8,
					background: 'rgba(255, 255, 255, 0.95)',
					backdropFilter: 'blur(20px)',
					borderRadius: '12px',
					boxShadow: '0 4px 16px rgba(76, 175, 80, 0.2)',
					border: '2px solid rgba(76, 175, 80, 0.3)',
					color: '#4CAF50',
					width: 40,
					height: 40,
					zIndex: 1000,
					'&:hover': {
						background: 'rgba(255, 255, 255, 1)',
						transform: 'scale(1.1) rotate(5deg)',
						boxShadow: '0 8px 24px rgba(76, 175, 80, 0.3)',
						border: '2px solid rgba(76, 175, 80, 0.5)',
					},
					transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
				}}>
				{isMenuCollapsed ? <MenuIcon /> : <ChevronLeftIcon />}
			</IconButton>

			{/* Main Menu - Completely hidden when collapsed */}
			{!isMenuCollapsed && (
				<Paper
					elevation={0}
					sx={{
						minWidth: '300px',
						width: '300px',
						position: 'fixed',
						top: 69,
						bottom: 0,
						marginRight: '5px',
						background: 'rgba(255, 255, 255, 0.98)',
						overflow: 'hidden',
						borderRight: '2px solid rgba(76, 175, 80, 0.2)',
						transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
						borderRadius: '0px',
						transform: isMenuCollapsed ? 'translateX(-100%)' : 'translateX(0)',
						opacity: isMenuCollapsed ? 0 : 1,
						visibility: isMenuCollapsed ? 'hidden' : 'visible',
						boxShadow: '0 8px 32px rgba(76, 175, 80, 0.15)',
					}}>
					{/* User Profile Section */}
					<Box
						sx={{
							background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
							padding: '24px 16px',
							position: 'relative',
							'&::after': {
								content: '""',
								position: 'absolute',
								bottom: 0,
								left: '50%',
								transform: 'translateX(-50%)',
								width: '70%',
								height: '3px',
								background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
							}
						}}>
						<Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
							<Avatar
								sx={{
									width: 60,
									height: 60,
									border: '3px solid rgba(255,255,255,0.4)',
									boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
									'&:hover': {
										transform: 'scale(1.05)',
										boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
									},
									transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
								}}
								alt={currentUser?.name}
								src={currentUser?.photo}
							/>
							<Box sx={{ ml: 2, flex: 1 }}>
								<Typography
									variant="h6"
									sx={{
										color: '#fff',
										fontWeight: 700,
										fontSize: '18px',
										textShadow: '0 2px 4px rgba(0,0,0,0.3)',
										mb: 0.5,
									}}>
									{currentUser?.name}
								</Typography>
								<Chip
									label={currentUser?.roleDescription}
									size="small"
									sx={{
										background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
										color: '#fff',
										fontWeight: 700,
										borderRadius: '12px',
										boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
										border: '1px solid rgba(255, 255, 255, 0.3)',
									}}
								/>
							</Box>
						</Box>
					</Box>

					{/* Copy Link Button */}
					<Box sx={{ p: 2 }}>
						<CopyToClipboard
							text={`https://quequan.vn/${currentUser.store}/`}
							onCopy={() => setCopied(true)}>
							<Button
								fullWidth
								variant="contained"
								startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
								sx={{
									background: copied 
										? 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)'
										: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
									color: 'white',
									padding: '12px 24px',
									borderRadius: '16px',
									border: 'none',
									boxShadow: copied 
										? '0 6px 20px rgba(76, 175, 80, 0.4)'
										: '0 6px 20px rgba(255, 107, 107, 0.4)',
									fontWeight: 700,
									fontSize: '14px',
									textTransform: 'uppercase',
									letterSpacing: '0.5px',
									'&:hover': {
										background: copied 
											? 'linear-gradient(135deg, #45A049 0%, #5CB85C 100%)'
											: 'linear-gradient(135deg, #FF5252 0%, #FF7043 100%)',
										transform: 'translateY(-2px)',
										boxShadow: copied 
											? '0 10px 30px rgba(76, 175, 80, 0.5)'
											: '0 10px 30px rgba(255, 107, 107, 0.5)',
									},
									transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
								}}>
								{copied ? 'Đã sao chép!' : 'Sao chép link đặt hàng'}
							</Button>
						</CopyToClipboard>
					</Box>

					<Divider sx={{ mx: 2, opacity: 0.3, height: '1px', background: 'linear-gradient(90deg, transparent, rgba(76, 175, 80, 0.3), transparent)' }} />

					{/* Menu Items */}
					<Box sx={{ p: 1, maxHeight: 'calc(100vh - 380px)', overflow: 'auto' }}>
						<List sx={{ p: 0 }}>
							{/* Admin Guest Orders */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('manageAllGuestOrder') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate(`/admin/guest-order`)}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<ShoppingCartOutlinedIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'ĐƠN KHÁCH ĐẶT'} 
											sx={menuTextStyle}
										/>
										{allGuestOrdersQuantity > 0 && (
											<Typography sx={badgeStyle}>
												{allGuestOrdersQuantity}
											</Typography>
										)}
									</ListItemButton>
								</ListItem>
							)}

							{/* Work Management */}
							{(currentUser.role === 'director' || currentUser.role === 'admin' || currentUser.role === 'assistant') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate(`/admin/task/store`)}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<DashboardOutlinedIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'QUẢN LÝ CÔNG VIỆC'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Zalo Mini App */}
							{currentUser.isLoggedIn && currentUser.role === 'admin' && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/admin/zalo-miniapp')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<PhoneAndroidIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'ZALO MINI APP'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Payment Management */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate(`/admin/bill`)}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<RequestQuoteIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'THANH TOÁN ĐƠN HÀNG'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Store Manager Guest Orders */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('manageGuestOrder') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate(`/store-manager/guest-order`)}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<ShoppingCartOutlinedIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'ĐƠN KHÁCH ĐẶT'} 
											sx={menuTextStyle}
										/>
										{guestOrdersQuantity > 0 && (
											<Typography sx={badgeStyle}>
												{guestOrdersQuantity}
											</Typography>
										)}
									</ListItemButton>
								</ListItem>
							)}

							{/* Transfer Info */}
							{currentUser.isLoggedIn &&
								currentUser.role !== 'director' &&
								currentUser.role !== 'admin' &&
								currentUser.role !== 'assistant' &&
								currentUser.permission.includes('updateTransferInfo') && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate(`/store-manager/transfer-info`)}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<InfoOutlinedIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'THÔNG TIN CK'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{/* Work Table */}
							{currentUser.isLoggedIn &&
								currentUser.role !== 'director' &&
								currentUser.role !== 'admin' &&
								currentUser.role !== 'assistant' && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate(`/user/task`)}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<DashboardOutlinedIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'BẢNG LÀM VIỆC'} 
												sx={menuTextStyle}
											/>
											{totalOrdersQuantityAndWeight?.totalQuantity > 0 && (
												<Box
													sx={{
														textAlign: 'right',
														ml: 1,
													}}>
													<Typography
														sx={{
															fontSize: '11px',
															fontWeight: 'bold',
															color: mainRed,
															lineHeight: 1.2,
														}}>
														{totalOrdersQuantityAndWeight?.totalQuantity} đơn
													</Typography>
													<Typography
														sx={{
															fontSize: '11px',
															fontWeight: 'bold',
															color: mainRed,
															lineHeight: 1.2,
														}}>
														{totalOrdersQuantityAndWeight?.totalWeight} kg
													</Typography>
												</Box>
											)}
										</ListItemButton>
									</ListItem>
								)}

							{/* Internal Sale */}
							{currentUser.isLoggedIn &&
								currentUser.role !== 'director' &&
								currentUser.role !== 'admin' &&
								currentUser.role !== 'assistant' &&
								currentUser.role !== 'staff' && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate(`/user/internal-sale`)}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<StorefrontOutlinedIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'MUA BÁN NỘI BỘ'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{/* Warehouse Management */}
							{currentUser.isLoggedIn &&
								(currentUser.permission?.includes('manageStock') ||
									currentUser.permission?.includes('manageStockByStore')) && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => {
											if (currentUser.permission?.includes('manageStock')) {
												navigate('/admin/stock')
												return
											}
											navigate('/warehouse-management')
										}}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<WarehouseIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'QUẢN LÝ KHO'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Approval Orders */}
							{currentUser.isLoggedIn &&
								(currentUser.permission?.includes('confirmCheckStock') ||
									currentUser.permission?.includes('confirmReImportFresh') ||
									currentUser.permission?.includes('confirmReImportCooked') ||
									currentUser.permission?.includes('confirmSellExport')) && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/store-manager/stock/confirm')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<CheckIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'DUYỆT ĐƠN'} 
												sx={menuTextStyle}
											/>
											{remainingConfirm > 0 && (
												<Typography sx={badgeStyle}>
													{remainingConfirm}
												</Typography>
											)}
										</ListItemButton>
									</ListItem>
								)}

							{/* Schedule Orders */}
							{currentUser.isLoggedIn && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => {
											if (currentUser.role === 'director' || currentUser.role === 'admin' || currentUser.role === 'assistant') {
												navigate('/admin/schedule')
											} else {
												navigate(`/user/schedule/store/${currentUser.store}`)
											}
										}}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<ScheduleIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'ĐƠN ĐẶT TRƯỚC'} 
											sx={menuTextStyle}
										/>
										{scheduleOrderQuantity > 0 && (
											<Typography sx={badgeStyle}>
												{scheduleOrderQuantity}
											</Typography>
										)}
									</ListItemButton>
								</ListItem>
							)}

							{/* User Management */}
							{(currentUser.role === 'director' || currentUser.role === 'admin') && (
								<>
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/admin/users')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<SupervisorAccountIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'QUẢN LÝ NGƯỜI DÙNG'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/admin/stores')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<StorefrontOutlinedIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'QUẢN LÝ CỬA HÀNG'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								</>
							)}

							{/* Role Management */}
							{currentUser.role === 'admin' && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/admin/roles')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<KeyOutlinedIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'PHÂN QUYỀN'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Tag Management */}
							{currentUser.permission?.includes('createTag') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => {
											if (currentUser.role === 'director' || currentUser.role === 'admin') {
												navigate('/admin/tags')
											} else {
												navigate(`/admin/tag/store/${currentUser?.store}`)
											}
										}}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<LocalOfferOutlinedIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'QUẢN LÝ TAG'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Store Manager Users */}
							{currentUser.role === 'storeManager' && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/store-manager/users')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<SupervisorAccountIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'QUẢN LÝ NGƯỜI DÙNG'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Statistics Sections */}
							<Divider sx={{ mx: 2, my: 2, opacity: 0.3, height: '1px', background: 'linear-gradient(90deg, transparent, rgba(76, 175, 80, 0.3), transparent)' }} />
							<Typography 
								variant="caption" 
								sx={{ 
									px: 3, 
									py: 1.5, 
									color: '#4CAF50', 
									fontWeight: 700,
									textTransform: 'uppercase',
									letterSpacing: '1px',
									fontSize: '11px',
									background: 'rgba(76, 175, 80, 0.08)',
									mx: 2,
									borderRadius: '6px',
									display: 'block',
									textAlign: 'center',
									border: '1px solid rgba(76, 175, 80, 0.2)',
								}}>
								Thống kê
							</Typography>

							{canUseCashflow && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton
										selected={location.pathname === '/cashflow'}
										onClick={() => navigate('/cashflow')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<AccountBalanceWalletIcon />
										</ListItemIcon>
										<ListItemText
											primary={'THU CHI'}
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Order Statistics */}
							{currentUser.isLoggedIn &&
								(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') &&
								currentUser.permission.includes('seeAllStoresStatistics') && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/admin/statistics/today')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<TableChartIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'THỐNG KÊ ĐƠN HÀNG'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{currentUser.isLoggedIn &&
								currentUser.role !== 'admin' &&
								currentUser.role !== 'director' &&
								currentUser.role !== 'assistant' &&
								currentUser.permission.includes('seeStatisticsByStore') && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/store-manager/statistics/today')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<TableChartIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'THỐNG KÊ ĐƠN HÀNG'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{/* Transfer Order Statistics */}
							{currentUser.isLoggedIn &&
								currentUser.permission.includes('transferStore') && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/store-manager/statistics/transfer-order')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<MoveUpIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'THỐNG KÊ ĐƠN CHUYỂN'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{/* Store Statistics */}
							{currentUser.isLoggedIn &&
								(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') &&
								currentUser.permission.includes('seeAllStoresStatistics') && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/admin/statistics')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<StackedBarChartOutlinedIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'THỐNG KÊ CỬA HÀNG'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{currentUser.isLoggedIn &&
								currentUser.role !== 'admin' &&
								currentUser.role !== 'director' &&
								currentUser.role !== 'assistant' &&
								currentUser.permission.includes('seeStatisticsByStore') && (
									<ListItem sx={{ p: 0 }}>
										<ListItemButton 
											onClick={() => navigate('/store-manager/statistics')}
											sx={menuItemStyle}>
											<ListItemIcon sx={menuIconStyle}>
												<StackedBarChartOutlinedIcon />
											</ListItemIcon>
											<ListItemText 
												primary={'THỐNG KÊ CỬA HÀNG'} 
												sx={menuTextStyle}
											/>
										</ListItemButton>
									</ListItem>
								)}

							{/* Revenue Statistics */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('seeRevenue') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => {
											if (currentUser.role !== 'admin' && currentUser.role !== 'director' && currentUser.role !== 'assistant') {
												navigate('/user/statistics')
											} else {
												navigate('/admin/statistics/user')
											}
										}}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<BarChartOutlinedIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'THỐNG KÊ DOANH THU'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Stock Statistics */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('seeAllStoresStockStatistics') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/admin/stock/statistics')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<AnalyticsIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'THỐNG KÊ CÁC KHO'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{currentUser.isLoggedIn && currentUser.permission?.includes('seeStockStatisticsByStore') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/store-manager/stock/statistics')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<AnalyticsIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'THỐNG KÊ KHO HÀNG'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Stock Forecast */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('seeStockForecast') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/admin/stock/forecast')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<CalendarMonthIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'DỰ BÁO TỒN KHO'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}

							{/* Stock History */}
							{currentUser.isLoggedIn && currentUser.permission?.includes('viewStockHistory') && (
								<ListItem sx={{ p: 0 }}>
									<ListItemButton 
										onClick={() => navigate('/store-manager/stock/view-history')}
										sx={menuItemStyle}>
										<ListItemIcon sx={menuIconStyle}>
											<ManageSearchIcon />
										</ListItemIcon>
										<ListItemText 
											primary={'LỊCH SỬ KHO'} 
											sx={menuTextStyle}
										/>
									</ListItemButton>
								</ListItem>
							)}
						</List>
					</Box>

					{/* Logout Button */}
					<Box sx={{ p: 2 }}>
						<Button
							fullWidth
							variant='contained'
							startIcon={<LogoutOutlinedIcon />}
							onClick={handleLogout}
							sx={{
								background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
								color: 'white',
								padding: '12px 24px',
								borderRadius: '16px',
								border: 'none',
								boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
								fontWeight: 700,
								fontSize: '14px',
								textTransform: 'uppercase',
								letterSpacing: '0.5px',
								'&:hover': {
									background: 'linear-gradient(135deg, #FF5252 0%, #FF7043 100%)',
									transform: 'translateY(-2px)',
									boxShadow: '0 10px 30px rgba(255, 107, 107, 0.5)',
								},
								transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
							}}>
							Đăng xuất
						</Button>
					</Box>
				</Paper>
			)}
		</>
	)
}
